import { memo } from 'react';

import { InvoiceProjectByStatus } from 'entities';

import { Column, Skeleton } from 'components/Blocks';

import SingleProject from './SingleProject';

interface CardViewProps {
  controls: InvoiceProjectByStatus[];
  loading?: boolean;
}

const SingleProjectMemo = memo(SingleProject);

export function InvoiceControlCards({ controls, loading }: CardViewProps) {
  if (loading) return <Skeleton quantity={5} height={58} />;

  return (
    <Column>
      {controls.map((control) => (
        <SingleProjectMemo key={`invoice-control-${control.project.id}`} control={control} />
      ))}
    </Column>
  );
}
